// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SearchInput_inputContainer__QPd4J","clearSearch":"SearchInput_clearSearch__IU9mw"};